<template>
  <div>
	<h1>Seite nicht gefunden</h1>
	Zurück zur <router-link to="/home">Home</router-link>-Seite oder zum <router-link to="/login">Login</router-link>.
  </div>
</template>

<script>
  export default {
    components: {},
    methods: {}
  }
</script>

<style>
</style>
